module.exports = __webpack_public_path__ + "img/play_action.478a24ff.svg";